import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useIdleLogout = (timeout = 10 * 60 * 1000, warningTime = 30 * 1000) => {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    let idleTimer;
    let warningTimer;

    const logout = () => {
      sessionStorage.removeItem("token");
      navigate("/");
    };

    const resetTimers = () => {
      clearTimeout(idleTimer);
      clearTimeout(warningTimer);
      setShowWarning(false);

      warningTimer = setTimeout(() => {
        setShowWarning(true);
      }, timeout - warningTime);

      idleTimer = setTimeout(() => {
        logout();
      }, timeout);
    };

    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimers));

    resetTimers();

    return () => {
      clearTimeout(idleTimer);
      clearTimeout(warningTimer);
      events.forEach((event) => window.removeEventListener(event, resetTimers));
    };
  }, [navigate, timeout, warningTime]);

  return { showWarning, stayLoggedIn: () => setShowWarning(false) };
};

export default useIdleLogout;
